import { useState } from 'react';
import { apiPatch } from '../lib/api';

// Inline pipeline-stage selector for the Contacts list (Phase 10 — stage tracking
// lives ON the contacts view now that the separate stage board/Dashboard is
// retired). Mirrors WorkStatus: optimistic, changing it PATCHes the contact and
// logs a stage_change to the timeline server-side.
export interface StageOpt { id: string; name: string }

export function StageControl({ contactId, value, stages, onChange }: {
  contactId: number; value: string | null; stages: StageOpt[]; onChange?: (v: string) => void;
}) {
  const [v, setV] = useState(value || '');
  const [busy, setBusy] = useState(false);

  async function set(next: string) {
    const prev = v;
    setV(next); setBusy(true); onChange?.(next);
    try { await apiPatch(`/api/contacts/${contactId}`, { stageId: next }); }
    catch { setV(prev); onChange?.(prev); }
    finally { setBusy(false); }
  }

  if (!stages.length) return null;
  return (
    <select
      value={v}
      disabled={busy}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => { e.stopPropagation(); set(e.target.value); }}
      className="cursor-pointer rounded-md border border-line bg-surface-3 px-2 py-0.5 text-xs font-semibold text-soft outline-none"
      title="Pipeline stage"
    >
      {stages.map((s) => <option key={s.id} value={s.id} className="bg-surface-2 text-soft">{s.name}</option>)}
    </select>
  );
}
